// extracted by mini-css-extract-plugin
export var header = "TextAndPicture-module--header--1DLgq";
export var leftColumn = "TextAndPicture-module--left-column--1yGps";